package calculator

fun publicScenarios(scenarios: List<ScenarioResult>): List<ScenarioResult> {
    return scenarios.filter { it.id != ScenarioId.E_VISA }
}

fun publicRanking(comparison: ComparisonResult): List<ScenarioResult> {
    return comparison.ranking.filter { it.id != ScenarioId.E_VISA }
}
